export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    type: 'seq',
    fixed: 'left',
  },
  {
    title: that.$l('table_label_displayContactAvatar') || '头像',
    field: 'displayAvatar',
    align: 'center',
    minWidth: 70,
    slots: { default: 'displayAvatar' },
  },
  {
    title: that.$l('table_label_displayContactName') || '姓名',
    field: 'displayName',
    headerAlign: 'center',
    align: 'left',
    minWidth: 160,
    slots: { default: 'displayName' },
  },
  {
    title: that.$l('table_label_contactMemo') || '业务职责说明',
    field: 'contactMemo',
    headerAlign: 'center',
    align: 'left',
    minWidth: 180,
  },
  {
    title: that.$l('table_label_displayContactMobile') || '联系电话',
    field: 'displayMobile',
    headerAlign: 'center',
    align: 'left',
    minWidth: 220,
    slots: { default: 'displayMobile' },
  },
  {
    title: that.$l('table_label_contactEmail') || '邮件地址',
    field: 'contactEmail',
    headerAlign: 'center',
    align: 'left',
    minWidth: 230,
  },
  {
    title: that.$l('table_label_contactAddress') || '通讯地址',
    field: 'contactAddress',
    headerAlign: 'center',
    align: 'left',
    minWidth: 230,
  },
  {
    title: that.$l('table_title_modifyInfo') || '数据更新',
    field: 'modifyInfo',
    minWidth: 170,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
    slots: { default: 'modifyInfo' },
  },
]
